import { useMemo } from "react";
import useWindowSize from "./useWindowSize";

const useIsTabletHook = () => {
  const window = useWindowSize();

  const isTablet = useMemo(() => {
    return window.width >= 768 && window.width < 1200;
  }, [window.width]);

  return isTablet;
};

export default useIsTabletHook;
